import DoTeleportRequestDTO from "../../models/teleport/DoTeleportRequestDTO";
import CommonResponse from "../../models/CommonResponse";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function doTeleport(client: BackendClient, request: DoTeleportRequestDTO): Promise<CommonResponse> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<CommonResponse>((resolve, reject) => {
      axios.post(`${client.getBackendUrl()}${BackendClient.DoTeleport}`, request ,{headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to teleport: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }